export const shouldUsePhoneInterview = (
  org: Org | null,
  jobs: Job | Array<Job> | null | undefined,
) => {
  if (!org || !jobs) {
    return false;
  }

  const jobIsTurnedOn = (j: Job) => j.usesPhoneInterview;
  const orgOverridesJob = (j: Job) => j.usesPhoneInterview !== false && org.usesPhoneInterview;
  const jobUsesPhoneInterview = (j: Job) => jobIsTurnedOn(j) || orgOverridesJob(j);

  if (Array.isArray(jobs)) {
    return jobs.some((j) => jobUsesPhoneInterview(j));
  }
  return jobUsesPhoneInterview(jobs);
};
